globalThis.jotaiAtomCache = globalThis.jotaiAtomCache || {
  cache: new Map(),
  get: function get(name, inst) {
    if (this.cache.has(name)) {
      return this.cache.get(name);
    }

    this.cache.set(name, inst);
    return inst;
  }
};
import _styled from "styled-components";
import { useEffect, useState, useCallback } from 'react';
import { ExclamationCircleIcon } from '@heroicons/react/24/outline';
import { ModalWrapperCloseIcon, useModal } from '@restworld/utils-common';
import { Title, Button, BaseModal, LinkBase } from '../../';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function JobExpireInformation(_ref) {
  var similarJobPositions = _ref.similarJobPositions,
      showRestaurantDetails = _ref.showRestaurantDetails,
      restaurantSlug = _ref.restaurantSlug;

  var _useState = useState(false),
      showSimilarPositions = _useState[0],
      similarPositionsToggler = _useState[1];

  var _useModal = useModal(),
      show = _useModal.show,
      open = _useModal.open,
      close = _useModal.close;

  var similarPositionToggler = useCallback(function () {
    return similarPositionsToggler(function (prev) {
      return !prev;
    });
  }, []);
  useEffect(function () {
    open(); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(function () {
    var similarJobsEl = document.getElementById('similar-jobs-el');

    if (similarJobsEl && showSimilarPositions) {
      close();
      similarJobsEl.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });
    }
  }, [close, showSimilarPositions]);
  return /*#__PURE__*/_jsx(BaseModal, {
    onClose: close,
    showMobileGestures: true,
    open: show,
    modalStyles: [{
      "width": "100%",
      "@media (min-width: 768px)": {
        "minWidth": "22rem",
        "maxWidth": "26rem"
      }
    }],
    closeIcon: /*#__PURE__*/_jsx(ModalWrapperCloseIcon, {}),
    children: /*#__PURE__*/_jsxs(Wrapper, {
      children: [/*#__PURE__*/_jsx(_StyledExclamationCircleIcon, {}), /*#__PURE__*/_jsx(Title, {
        isCenter: true,
        fontSize: "large",
        content: modalTitle,
        textColor: "black",
        fontWeight: "semibold",
        variant: "h3-large",
        twStyle: {
          "marginBottom": "0.5rem",
          "lineHeight": "1.75rem"
        }
      }), /*#__PURE__*/_jsx(Title, {
        variant: "h6-large",
        textColor: "gray-500",
        twStyle: {
          "marginBottom": "1.75rem"
        },
        children: modalBody
      }), /*#__PURE__*/_jsxs(_StyledDiv, {
        children: [similarJobPositions.length > 0 ? /*#__PURE__*/_jsx(Button, {
          fullwidth: true,
          title: "Mostra posizioni simili",
          variant: "normal",
          onClick: similarPositionToggler
        }) : null, /*#__PURE__*/_jsxs(LinkBase, {
          link: showRestaurantDetails ? "/locale/".concat(restaurantSlug) : '/cerco-lavoro',
          newTab: false,
          twStyle: {
            "width": "100%"
          },
          children: [' ', /*#__PURE__*/_jsx(Button, {
            fullwidth: true,
            title: showRestaurantDetails ? 'Esplora pagina del locale' : 'Esplora tutte le posizioni',
            variant: "secondary-outline"
          })]
        })]
      })]
    })
  });
}
export default JobExpireInformation;

var Wrapper = /*#__PURE__*/_styled.div.withConfig({
  displayName: "job-expire-information__Wrapper",
  componentId: "sc-wnhmj5-0"
})({
  "display": "flex",
  "flexDirection": "column",
  "alignItems": "center"
});

var modalTitle = "La candidatura non \xE8 pi\xF9 attiva per questa posizione";
var modalBody = "Questa posizione \xE8 stata gi\xE0 occupata o chiusa. Trova nuove possibilit\xE0 o usa l\u2019autocandidatura sulla pagina del locale per altre opportunit\xE0!";

var _StyledExclamationCircleIcon = /*#__PURE__*/_styled(ExclamationCircleIcon).withConfig({
  displayName: "job-expire-information___StyledExclamationCircleIcon",
  componentId: "sc-wnhmj5-1"
})({
  "marginBottom": "1rem",
  "height": "3.25rem",
  "width": "3.25rem",
  "--tw-text-opacity": "1",
  "color": "rgb(186 0 31 / var(--tw-text-opacity))"
});

var _StyledDiv = /*#__PURE__*/_styled("div").withConfig({
  displayName: "job-expire-information___StyledDiv",
  componentId: "sc-wnhmj5-2"
})({
  "display": "flex",
  "width": "100%",
  "flexDirection": "column",
  "alignItems": "center",
  "gap": "1rem"
});